import { Autocomplete, TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../hooks/use-is-mobile';
import { COMMON_UNITS, getUnitLabel } from '../utils/units';

interface UnitAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  sx?: SxProps<Theme>;
}

export function UnitAutocomplete({
  value,
  onChange,
  onBlur,
  label,
  size,
  fullWidth,
  error,
  helperText,
  sx,
}: UnitAutocompleteProps) {
  const { t } = useTranslation('goodsReceiving');
  const isMobile = useIsMobile();

  return (
    <Autocomplete
      value={value || null}
      onChange={(_, newValue) => onChange((newValue as string) || '')}
      onBlur={onBlur}
      options={[...COMMON_UNITS]}
      getOptionLabel={(option) => getUnitLabel(option as string)}
      fullWidth={fullWidth}
      size={size}
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label ?? t('unitLabel')}
          placeholder={t('unitPlaceholder')}
          error={error}
          helperText={helperText}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps?.input,
              style: { fontSize: isMobile ? '16px' : undefined },
            },
          }}
        />
      )}
    />
  );
}
